<div class="ais-RefinementList">
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
    >
      <span *ngIf="options.label === 'CATALOG.FILTERS.CATEGORY'" i18n="@@CATALOG.FILTERS.CATEGORY">Category</span>
      {{ options.label }}
    </button>
  </div>
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <ul class="filters__checkboxList" [ngClass]="{'filters__checkboxList--reduce': !isShowingMore}">
      <li *ngFor="let item of items">
        <input
          id="filters_checkbox__{{ options.facet }}__{{ item.id }}"
          class="filters_checkbox_input"
          type="checkbox"
          (change)="refine($event, item)"
          [attr.checked]="item.isRefined ? 'checked' : null"
        />
        <label for="filters_checkbox__{{ options.facet }}__{{ item.id }}" class="filters_checkbox_label">
          {{ item.label }} <span class="filters_checkbox_label_count">({{ item.count }})</span>
        </label>

        <ul class="filters_subCategoryList">
          <li *ngFor="let subitem of item.data">
            <input
              id="filters_checkbox__{{ options.facet }}__{{ item.id }}__{{ subitem.id }}"
              class="filters_checkbox_input"
              type="checkbox"
              (change)="refine($event, subitem)"
              [attr.checked]="subitem.isRefined ? 'checked' : null"
            />
            <label
              for="filters_checkbox__{{ options.facet }}__{{ item.id }}__{{ subitem.id }}"
              class="filters_checkbox_label"
              >{{ subitem.label }} <span class="filters_checkbox_label_count">({{ subitem.count }})</span>
            </label>
          </li>
        </ul>
      </li>
    </ul>

    <vc-show-more-button
      *ngIf="options.showMoreLimit && items.length > 10"
      [isShowingMore]="isShowingMore"
      (toggleShowMore)="toggleShowMore()"
    ></vc-show-more-button>
  </div>
</div>
